import React, { useContext, useState } from 'react'
import { Button, View } from 'oio-react'
import { CheckmarkCircledIcon } from 'assets/icons'
import { useMe, useSubmitSurvey, useSurveyResults } from 'src/core/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'

const FormBlock = () => {
   const [selectedAnswer, setSelectedAnswer] = useState()
   const { initiative, refetchInitiative } = useContext(InitiativeHierarchyContext)
   const { isLoggedIn } = useMe()
   const { refetch: refetchSurveyResults } = useSurveyResults({ initiativeId: initiative.id })
   const { submitSurvey, mutating } = useSubmitSurvey()

   const handleSurveySubmit = async () => {
      if (!isLoggedIn) {
         return window.alert('Please login to participate in this poll')
      }

      try {
         const formData = [{
            elementId: initiative.appsSurveyFormElements[0].id,
            value: selectedAnswer
         }]

         await submitSurvey({ formData, initiativeId: initiative.id })
         await Promise.all([refetchSurveyResults(), refetchInitiative()])
      } catch (err) {
         window.alert('Whoops, there was an error casting your vote!')
         console.log(err) // eslint-disable-line no-console
      }
   }

   return (
      <>
         <View margin="15px 0px 20px 0px">
            {initiative.appsSurveyFormElements[0].options.map(option => (
               <View
                  key={option}
                  onClick={() => setSelectedAnswer(option)}
                  display="flex"
                  alignItems="center"
                  height="30px"
                  style={{ color: '#555' }}>
                  <View marginTop="4px" marginRight="15px">
                     {selectedAnswer === option && (
                        <CheckmarkCircledIcon
                           width="18px"
                           height="18px"
                           color="#7d3ce7"
                        />
                     )}
                     {selectedAnswer !== option && (
                        <View
                           width="18px"
                           height="18px"
                           border="2px solid #ccc"
                           borderRadius="50%"
                        />
                     )}
                  </View>
                  {option}
               </View>
            ))}
         </View>
         <Button
            onClick={handleSurveySubmit}
            size="md"
            color="#7d3ce7"
            mode={mutating ? 'loading' : 'normal'}
            name="Submit Vote"
            padding="20px"
         />
      </>
   )
}

export default FormBlock
